<template>
  <form @submit.prevent="validateBeforeSubmit">
      <section class="uk-margin-bottom">
        <header class="modal-card-head">
          <p class="modal-card-title">Настройки сайта</p>
        </header>
      </section>
      <section>
        <div class="columns">
          <div class="column is-4">
            <b-field
              label="Центр карты: Широта">
              <b-input
                name="latitude"
                placeholder="43.8062302"
                v-validate="'required'"
                icon="map-marker-alt"
                v-model="model.latitude">
              </b-input>
            </b-field>
            <b-field
              label="Центр карты: Долгота">
              <b-input
                name="longitude"
                placeholder="35.7006469"
                v-validate="'required'"
                icon="map-marker-alt"
                v-model="model.longitude">
              </b-input>
            </b-field>
            <b-field label="Регистрация администраторов">
              <b-select placeholder="Состояние регистрации администраторов" expanded v-model="model.allow_signup">
                <option
                  v-for="option in allow_signup"
                  :value="option.id"
                  :key="option.id">
                  {{ option.name }}
                </option>
              </b-select>
            </b-field>
            <b-field label="Уведомления">
              <b-select placeholder="Состояние уведомлений" expanded v-model="model.notify">
                <option
                  v-for="option in notify"
                  :value="option.id"
                  :key="option.id"
                  :disabled="option.disabled">
                  {{ option.name }}
                </option>
              </b-select>
            </b-field>
          </div>
          <div class="column is-4">
            <b-field label="Капча">
              <b-select placeholder="Состояние защиты от ботов" expanded v-model="model.captcha_enabled">
                <option
                  v-for="option in captcha"
                  :value="option.id"
                  :key="option.id"
                  :disabled="option.disabled">
                  {{ option.name }}
                </option>
              </b-select>
            </b-field>
            <b-field
              label="Ключ от Google reCaptcha: Site key">
              <b-input
                name="captcha_sitekey"
                placeholder="Google reCaptcha Site key"
                v-validate="'required'"
                icon="key"
                v-model="model.captcha_sitekey">
              </b-input>
            </b-field>
            <b-field
              label="Ключ от Google reCaptcha: Secret key">
              <b-input
                name="captcha_sitekey"
                placeholder="Google reCaptcha Secret key"
                v-validate="'required'"
                icon="key"
                v-model="model.captcha_secretkey">
              </b-input>
            </b-field>
            <b-field
              label="Ключ от Google Map">
              <b-input
                name="gmap_apikey"
                placeholder="Google Map API Key"
                v-validate="'required'"
                icon="key"
                v-model="model.gmap_apikey">
              </b-input>
            </b-field>
          </div>
          <div class="column is-4">
            <b-field
              label="SMTP Сервер">
              <b-input
                name="smtp_server"
                placeholder="smtp.yandex.ru:465"
                v-validate="'required'"
                icon="server"
                v-model="model.smtp_server">
              </b-input>
            </b-field>
            <!-- <b-field
              label="IMAP Сервер">
              <b-input
                name="imap_server"
                placeholder="imap.yandex.ru:993"
                v-validate="'required'"
                icon="server"
                v-model="model.imap_server">
              </b-input>
            </b-field> -->
            <b-field
              label="Mail username">
              <b-input
                name="mail_username"
                placeholder="web-catalog@cktspb.ru"
                v-validate="'required'"
                icon="user"
                v-model="model.mail_username">
              </b-input>
            </b-field>
            <b-field
              label="Mail password">
              <b-input
                name="mail_password"
                type="password"
                placeholder="******"
                v-validate="'required'"
                icon="key"
                v-model="model.mail_password">
              </b-input>
            </b-field>
            <b-field
              label="Mail Subject">
              <b-input
                name="mail_subject"
                placeholder="order web-catalog@cktspb.ru"
                v-validate="'required'"
                icon="list"
                v-model="model.mail_subject">
              </b-input>
            </b-field>
          </div>
        </div>
        <footer class="modal-card-foot">
          <button class="button is-primary">Сохранить</button>
        </footer>
      </section>   
  </form>
</template>

<script>
import Vue from 'vue'
import VeeValidate from 'vee-validate'
Vue.use(VeeValidate, {
    events: '',
});

import { EventBus } from '@/utils'
import '@fortawesome/fontawesome-free/css/all.css'
export default {
  name: 'SettingForm',
  components: {
    //
  },
  props: {
    title: String
  },
  data: function () {
    const allow_signup = [
      {
        id: true,
        name: "Включено",
        disabled: false
      },
      {
        id: false,
        name: "Выключено",
        disabled: false
      }
    ]
    const notify = [
      {
        id: null,
        name: "Не известно",
        disabled: true
      },
      {
        id: true,
        name: "Включено",
        disabled: false
      },
      {
        id: false,
        name: "Выключено",
        disabled: false
      }
    ]
    const captcha = [
      {
        id: null,
        name: "Не известно",
        disabled: true
      },
      {
        id: true,
        name: "Включено",
        disabled: false
      },
      {
        id: false,
        name: "Выключено",
        disabled: false
      }
    ]
    return {
      notify: notify,
      captcha: captcha,
      allow_signup: allow_signup,
      disabled_check: false,
      model: {
        map_center: null,
        notify: null,
        captcha_enabled: null,
        captcha_sitekey: null,
        gmap_apikey: null,
        smtp_server: null,
        imap_server: null,
        mail_username: null,
        mail_password: null
      }
    }
  },
  created: function() {
    //
  },
  computed: {
    //
  },
  beforeMount: function(){
    //
  },
  mounted () {
    let $this = this

    this.$store.dispatch('getSettings')
    .then(response => {
        let data = response.data.data;
        $this.model = data
    })
    .catch(error => {
        this.model = {}
    })

    EventBus.$on('successUpdateSettings', (data) => {
      this.$toast.open({
        message: this.$i18n.t('admin.setting_success_message'),
        type: 'is-success',
        position: 'is-bottom'
      })
    })

  },
  beforeDestroy: function(){
    EventBus.$off('successUpdateSettings')
  },
  methods: {
    validateBeforeSubmit() {
      let $this = this
      this.$validator.validateAll().then((result) => {
        if (result) {
          $this.doUpdate()
          return;
        }
        this.$toast.open({
          message: $this.$i18n.t('notify.form_error'),
          type: 'is-danger',
          position: 'is-bottom'
        })
      });
    },
    doUpdate () {
      let $this = this
      this.$dialog.confirm({
        message: $this.$i18n.t('admin.setting_message'),
        cancelText: $this.$i18n.t('admin.no'),
        confirmText: $this.$i18n.t('admin.yes'),
        onConfirm: () => {
          
          $this.$store.dispatch('updateSettings', $this.model)          

        }
      })
    },
    doCheckMailSetting(){
      this.$store.dispatch('checkEmailSetting')
      .then(response => {
      })
      .catch(error => {
      })
    }
  }
}
</script>

<style scoped>
</style>
<style>
</style>